import React from 'react';
import BaseGridToolbar, { FilterConfig } from '../../base-ui/Grid/components/BaseGridToolbar';

interface TeamGridToolbarProps {
    filter: string;
    setFilter: React.Dispatch<React.SetStateAction<string>>;
    role: string;
    setRole: React.Dispatch<React.SetStateAction<string>>;
    company: string;
    setCompany: React.Dispatch<React.SetStateAction<string>>;
    allData: any[];
    handleRefresh?: () => void;
    onAdd?: () => void;
}

const TeamGridToolbar: React.FC<TeamGridToolbarProps> = ({
    filter,
    setFilter,
    role,
    setRole,
    company,
    setCompany,
    allData,
    handleRefresh,
    onAdd
}) => {
    // Filter configurations specific to team members
    const filterConfigs: FilterConfig[] = [
        {
            field: 'role',
            label: 'Role',
            extractUnique: (data) => data.map(row => row.role).filter(Boolean)
        },
        {
            field: 'company',
            label: 'Company',
            extractUnique: (data) => data.map(row => row.company).filter(Boolean)
        }
    ];

    // Convert individual state to filters object
    const filters = { role, company };
    const setFilters = (newFilters: Record<string, string>) => {
        setRole(newFilters.role || '');
        setCompany(newFilters.company || '');
    };

    return (
        <BaseGridToolbar
            filter={filter}
            setFilter={setFilter}
            filters={filters}
            setFilters={setFilters}
            filterConfigs={filterConfigs}
            allData={allData}
            handleRefresh={handleRefresh}
            onAdd={onAdd}
            addButtonLabel="Add Team Member"
        />
    );
};

export default TeamGridToolbar;